import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
const BadgeContent = ({ authorName, groupName, }) => {
    const theme = useTheme();
    const { app } = usePlatform();
    const displayText = useMemo(() => {
        if (app === 'client' && authorName) {
            return authorName;
        }
        return groupName ? `${groupName} @ ${authorName}` : authorName;
    }, [authorName, groupName, app]);
    return (_jsx(Typography, { elementTheme: "overline", style: { textTransform: 'none' }, color: theme.colors.grey_3, children: displayText }));
};
export default BadgeContent;
